// extracted by mini-css-extract-plugin
module.exports = {"minimumScreenWidth":"320px","mobileScreenWidth":"600px","img":"style_img__2Eb87","img__disabled":"style_img__disabled__1rezE"};